import { ApiPlugin } from '@/plugins';

export default class FavouriteService {
  static fetchFavourite() {
    return ApiPlugin.get('/api/user-flags/favorite');
  }

  static addFavourit(id) {
    const bodyFormData = new FormData();
    bodyFormData.append('group', 'find');
    return ApiPlugin.post(`/api/user-flags/favorite/${id}`, bodyFormData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  static deleteFavourit(id) {
    const bodyFormData = new FormData();
    bodyFormData.append('group', 'find');
    return ApiPlugin.delete(`/api/user-flags/favorite/${id}`, bodyFormData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}
